<template>
  <div class="custom-time">
    <custom-time-header>
      {{desc}}
    </custom-time-header>
    <custom-time-picker
      :hours="hours"
      :mins="mins"
      :selectHourIndex="selectHourIndex"
      :selectMinIndex="selectMinIndex"
      :switchType="switchType"
      :switchTypeFlag="switchTypeFlag"
      @switchPush="switchPush"
      @changeSwitch="changeSwitch"
      @selectTime="selectTime"/>
    <!--订制完成后的弹窗-->
    <custom-time-bubble @closeBubble="closeBubble" v-if="isBubbleShow">
      {{confirmTime.hour < 10 ? '0'+confirmTime.hour:confirmTime.hour}}:{{confirmTime.min < 10 ? '0'+confirmTime.min:confirmTime.min}}
    </custom-time-bubble>
  </div>
</template>

<script>
  import keys from 'lodash.keys'
  import api from '@edu-fe/api'
  import module from '../modules/custom-time'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import CustomTimeHeader from '../components/Custom/CustomTimeHeader'
  import CustomTimePicker from '../components/Custom/CustomTimePicker'
  import CustomTimeBubble from '../components/Custom/CustomTimeBubble'

  export default {
    computed: {
      ...mapState(module.name, keys(module.state())),
      ...mapGetters(module.name, keys(module.getters)),
      /*
      *  根据url中参数控制是订制课程推送或者早点推送
      * */
      type () {
        this.set({ selectType: parseInt(this.$route.query.type) || 1 })
        return parseInt(this.$route.query.type) || 1
      },
      desc () {
        return this.type === 1 ?'订阅课程个性化学习时间':'职场早点个性化推送时间'
      }
    },
    methods: {
      ...mapMutations(module.name, keys(module.mutations)),
      ...mapActions(module.name, keys(module.actions)),
      closeBubble () {
        this.set({ isBubbleShow: false })
      },
      switchPush () {
        api.custom.switch()
      },
      changeSwitch () {
        this.set({switchType: !this.switchType})
      }
    },
    beforeCreate () {
      this.$store.registerModule(module.name, module)
    },
    created () {
      this.init()
    },
    beforeDestroy () {
      this.$store.unregisterModule(module.name)
    },
    components: {
      CustomTimeHeader,
      CustomTimePicker,
      CustomTimeBubble
    }
  }
</script>

<style lang="scss" scoped>
  @charset "UTF-8";
  @import "../style/main";

  .custom-time {
    min-height: 100vh;
    background: #F7F8FA;
    padding-bottom: rem(40);
  }
</style>
